import { fetchMainData, } from "public/Store/store-actions.js";
import {
    multiStatefeedCardRepeater,
    getRecentProducts
} from "public/Store/store-helper";
import wixLocation from 'wix-location';
import store from 'store';

let CURRENT_INDEX = 0;

export async function initialLoading() {
    await fetchMainData('design');
    CURRENT_INDEX = 0;

    const props = await store.get('props');
    const recentProducts = await store.get('recentProducts');

    await updateUI(props, recentProducts);
    setupButtonEventListeners(false);

}

export async function checkAndUpdateBtnStatus(productList, isMobile) {
    const maxSize = productList.length;
    const { noOfItemsForSlider, selectedTemplate } = await store.get('props');

    const nextButton = isMobile ? $w(`#template4NextButton`) : $w(`#${selectedTemplate}NextButton`);
    const prevButton = isMobile ? $w(`#template4PrevButton`) : $w(`#${selectedTemplate}PrevButton`);

    // Enable both buttons first
    nextButton.enable();
    prevButton.enable();

    if (CURRENT_INDEX + (isMobile ? 1 : noOfItemsForSlider) >= maxSize) {
        nextButton.disable();
    }

    if (CURRENT_INDEX <= 0) {
        prevButton.disable();
    }
}

export async function loadAndFilterProducts(viewMode, recentProducts) {
    const isProductPage = wixLocation.url.includes('/product-page/');
    const isSite = viewMode === 'Site';

    if (isProductPage && isSite) {
        recentProducts = await filterOutCurrentProduct(recentProducts);
        store.set('recentProducts', recentProducts)
    }
}

export async function changeTemplateState(selectedTemplate) {
    return $w("#templateMultiStateBox").changeState(`${selectedTemplate}State`);
}

export async function updateUI(props, recentProducts) {
    let viewMode = await store.get('viewMode');
    let { selectedTemplate, noOfItemsForSlider } = await store.get('props');
    let filteredProducts = await loadAndFilterProducts(viewMode, recentProducts);
    recentProducts = await store.get('recentProducts');

    await changeTemplateState(selectedTemplate);
    await $w(`#${selectedTemplate}ViewMultiState`).changeState(
        `${selectedTemplate}Items${noOfItemsForSlider}RepeaterContainer`
    );

    const productsToShow = recentProducts.slice(CURRENT_INDEX, CURRENT_INDEX + noOfItemsForSlider);
    await multiStatefeedCardRepeater(
        productsToShow,
        props,
        false
    );
    await checkAndUpdateBtnStatus(recentProducts, false);
}

export async function updateMobileUI(props, recentProducts) {
    let selectedTemplate = 'template4';
    let noOfItemsForSlider = 1;

    await changeTemplateState(selectedTemplate);
    await $w(`#${selectedTemplate}ViewMultiState`).changeState(
        `${selectedTemplate}Items${noOfItemsForSlider}RepeaterContainer`
    );
    const productsToShow = recentProducts.slice(CURRENT_INDEX, CURRENT_INDEX + noOfItemsForSlider);

    await multiStatefeedCardRepeater(
        productsToShow,
        props,
        true
    );
    await checkAndUpdateBtnStatus(recentProducts, true);
}

export async function setupButtonEventListeners(isMobile) {
    const props = await store.get('props');

    if (!isMobile) {
        $w(`#${props.selectedTemplate}NextButton`).onClick(() =>
            updateDisplayedItems(props.noOfItemsToShow)
        );
        $w(`#${props.selectedTemplate}PrevButton`).onClick(() =>
            updateDisplayedItems(-props.noOfItemsToShow)
        );
    } else {
        $w(`#template4NextButton`).onClick(() =>
            updateDisplayedItems(props.noOfItemsToShow)
        );
        $w(`#template4PrevButton`).onClick(() =>
            updateDisplayedItems(-props.noOfItemsToShow)
        );
    }
}

export async function updateDisplayedItems(step) {
    const recentProducts = await store.get('recentProducts');
    const formFactor = await store.get('formFactor');
    const props = await store.get('props');
    const maxSize = recentProducts.length;

    // Calculate the new index but constrain it within valid bounds
    const newIndex = Math.max(0, Math.min(CURRENT_INDEX + step, maxSize - 1));

    // Check if CURRENT_INDEX actually changes
    if (newIndex !== CURRENT_INDEX) {
        CURRENT_INDEX = newIndex;

        await updateUI(props, recentProducts);

    }
}

export async function handleOnPropsChanged(newProps) {
    const recentProducts = await store.get('recentProducts');

    await updateUI(newProps, recentProducts);
}

// Filter out the current product from the recent products list
export async function filterOutCurrentProduct(recentProducts) {
    const props = await store.get('props');
    return recentProducts.filter(product => product._id !== props.productId);
}

export async function handleProductIdChanged(newProps) {
    let recentProducts = await getRecentProducts();
    store.set('recentProducts', recentProducts);
    await updateUI(newProps, recentProducts);
}

export function isPropChanged(propName) {
    const newProps = store.get('props');
    const oldProps = store.get('oldProps');
    return newProps[propName] !== oldProps[propName];
}